import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
} from '@packages/tracking';
import { useTracking } from '@packages/tracking';

export const useShareButtonTracking = () => {
  const dispatchTracking = useTracking();

  const trackButtonClick = () => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: 'ShareButton',
      },
    });
  };

  const trackViewButton = () => {
    dispatchTracking<GTMEventGlycerinDisplayButton>({
      event: 'DisplayButton',
      DisplayButtonData: {
        category: 'ShareButton',
      },
    });
  };

  return {
    trackButtonClick,
    trackViewButton,
  };
};
